export const useCart = () => {
    const items = () => useState('cart', () => [])
    const useItems = items();
    const add = (item) => {
        useItems.value.push(item);
        trackAdd(item);
    };

    const checkout = (toAddPromoCode, useCartAttributes = false) => {
        trackCheckout(useItems.value);
        const appendPromo = toAddPromoCode ? toAddPromoCode : '';
        const shop = 'lifeboostcoffee';
        
        if(useItems.value.some(item => item.selling_plan)){
            const subscriptionItems = useItems.value.map(item => {
                let itemUrl = `items[][id]=${item.id}%26items[][quantity]=${item.qty}`;
                if (item.selling_plan) {
                    itemUrl += `%26items[][selling_plan]=${item.selling_plan}`;
                }
                // Add line item attributes if enabled
                if (useCartAttributes) {
                    itemUrl += `%26items[][properties][_ctf_prc]=${item.price}%26items[][properties][_ctf_ttl]=${encodeURIComponent(item.title)}`;
                }
                return itemUrl;
            }).join('%26');
            
            // Add cart-level attributes if enabled
            let cartAttributes = '';
            if (useCartAttributes) {
                // Get product IDs for cart attribute
                const productIds = useItems.value.map(item => item.id);
                console.log(document.location.pathname);
                cartAttributes = `%26attributes[Sale+Page%3A]=${encodeURIComponent(document.location.pathname)}%26attributes[_ctf_mst_prd]=${encodeURIComponent(JSON.stringify(productIds))}`;
            }
        
            const subscriptionUrl = `https://${shop}.com/cart/clear?return_to=/cart/add?${subscriptionItems}${cartAttributes}%26return_to=/checkout${appendPromo}`;
            window.location.href = subscriptionUrl;
        } else {
            const lineItems = useItems.value.map(item => `${item.id}:${item.qty}`).join(',');
            
            if (useCartAttributes) {
                // Build items like in selling plan flow (without selling_plan)
                const standardItems = useItems.value.map(item => {
                    let itemUrl = `items[][id]=${item.id}%26items[][quantity]=${item.qty}`;
                    itemUrl += `%26items[][properties][_ctf_prc]=${item.price}%26items[][properties][_ctf_ttl]=${encodeURIComponent(item.title)}`;
                    return itemUrl;
                }).join('%26');

                // Add cart-level attributes
                const productIds = useItems.value.map(item => item.id);
                const cartAttributes = `%26attributes[Sale+Page%3A]=${encodeURIComponent(document.location.pathname)}%26attributes[_ctf_mst_prd]=${encodeURIComponent(JSON.stringify(productIds))}`;

                const nonSubscriptionUrl = `https://${shop}.com/cart/clear?return_to=/cart/add?${standardItems}${cartAttributes}%26return_to=/checkout${appendPromo}`;
                window.location.href = nonSubscriptionUrl;
            } else {
                const standardUrl = `https://${shop}.com/cart/${lineItems}${appendPromo}`;
                window.location.href = standardUrl;
            }
        }
    }
    
    return {
        items,
        add,
        checkout
    };
}
